module.exports = __webpack_public_path__ + "static/img/avatar4.1ee77dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar4.png
// module id = ZS9R
// module chunks = 0